// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__31nsj","newExpiryDate":"styles_newExpiryDate__sr5v3","footer":"styles_footer__2QokZ"};